import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems, timeValueTasks } from '../data/drum';
import { PAGE_LESSON_NOTES } from '../data/pageSamples';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-19" data-mp="6v9559gbh7kl">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-20" data-mp="1vmosr56zb7k">
        <div className="lg:col-span-7" data-id="element-21" data-mp="1ubnqz34shk5">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-22" data-mp="gsnk14mldoas">
            Who is <em className="text-red-700" data-id="element-23" data-mp="bulzef9ipgx7">DRUM READY™</em> for?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-900/75" data-id="element-24" data-mp="pkz8wm2253on">This package is for you if you:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-slate-900/15 sm:grid-cols-2" data-id="element-25" data-mp="ljvpjpkswpio">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-slate-900/10 py-4 leading-snug text-slate-900/80" data-id="element-26" data-mp="zilsvmy7rlfh">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-27" data-mp="ulmuutbfiuc0" />
                {item}
              </li>)}
          </ul>
          <figure className="mx-auto mt-10 max-w-sm" data-id="element-28" data-mp="1bbjg5txap1w1">
            <img src={PAGE_LESSON_NOTES} alt="Volume 1, page 11: Lesson Notes & Weekly Assignment" loading="lazy" className="block aspect-[4/5] w-full rounded-lg border border-slate-900/10 bg-white object-contain shadow-xl shadow-slate-900/15" data-id="element-29" data-mp="1be5ldmwpr5b3" />
            <figcaption className="mt-3 text-center text-sm text-slate-900/60" data-id="element-30" data-mp="1pcm1g4ggu85w">Volume 1 · Lesson Notes & Weekly Assignment (page 11)</figcaption>
          </figure>
          <p className="mt-8 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-31" data-mp="1u8klxgyob611">
            Made for drum teachers who want to spend less time preparing and more time teaching.
          </p>
        </div>

        <aside className="self-start rounded-3xl bg-slate-900 p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-32" data-mp="282bscgh3y9sj">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-33" data-mp="2d158yhroygwx">What is your time worth?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-34" data-mp="cyvxepp3y6bv">
            Think about how many hours you spend every week on:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-35" data-mp="8z5166gtaxzy">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-36" data-mp="mq9s8k646hyo">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-37" data-mp="wn4oewex069s">
            Now imagine one organized package that helps with all of it – the whole studio year.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-red-300" data-id="element-38" data-mp="rq5y6oydgjgv">
            You don’t have to keep starting from zero.
          </p>
        </aside>
      </div>
    </section>;
}